<template>
    <div v-show="visible" class="modal modal--forgot-to-add-modal">
        <div class="modal__header">
            <span class="modal__title">Кажется, вы что-то забыли...</span>
        </div>
        <div class="modal__description">
            <span>С нашими соусами, васаби и имбирём гораздо вкуснее,
                не забудьте добавить их в корзину!</span>
        </div>
        <div class="modal__img">
            <img src="/images/soputka.png" alt="сопутствующие товары">
        </div>

        <div class="modal__buttons">
            <div class="btn btn--white button_without_spices" @click="createWithoutSpices">Заказать без специй</div>
            <div class="btn btn--red" @click="goToSpices">Добавить</div>
        </div>
        <div class="modal__close btn btn--remove" @click="close"></div>
    </div>
</template>

<script>
export default {
    name: 'forgot-to-add-modal',
    props: {
        visible: Boolean
    },
    watch: {
        visible(val) {
            val ? document.body.classList.add('modal-open') : document.body.classList.remove('modal-open')
        }
    },
    methods: {
        goToSpices() {
            document.getElementById('product-slider')?.scrollIntoView({behavior: 'smooth', block: 'center'})
            this.close()
        },
        createWithoutSpices() {
            this.close()
            this.$emit('create-without-spices')
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style scoped lang="scss">
.modal {
    &--forgot-to-add-modal {
        display: grid;
        grid-column-gap: 80px;
        padding: 32px 45px;
        width: 935px;
        justify-content: space-between;
        grid-template-areas:
            'img header'
            'img description'
            'img description'
            'img description'
            'img description'
            'img buttons';

        @media (max-width: 1100px) {
            gap: 30px;
            width: 400px;
            grid-template-areas: 'header' 'description' 'img' 'buttons';

            @media (max-width: 700px) {
                gap: 15px;
                width: 340px;
                padding: 32px;
                grid-template-areas: 'header' 'description' 'img' 'buttons';
            }
        }
    }
    &__header {
        grid-area: header;
        padding-top: 20px;
    }
    &__description {
        grid-area: description;

        span {
            font-family: Roboto, sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;

            @media (max-width: 700px) {
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
            }
        }
    }
    &__img {
        grid-area: img;
        margin: 0 auto;

        img {
            @media screen and (max-width: 700px) {
                width: 270px;
            }
        }
    }
    &__buttons {
        grid-area: buttons;
        display: flex;
        justify-content: space-between;
        height: 48px;

        @media (max-width: 1100px) {
            display: flex;
            flex-direction: column-reverse;
            gap: 15px;
            height: auto;
        }
    }
}
.modal__buttons .btn {
    padding: 14px 40px;
}

.button_without_spices {
    color: #333;
    text-align: center;
    font-family: Roboto,sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    border-color: #333;
}
</style>




